var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1743:173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.3824 88.4838H9.61768V46.8088C9.61768 44.5342 11.4616 42.6902 13.7363 42.6902H82.2638C84.5384 42.6902 86.3824 44.534 86.3824 46.8088V88.4838Z",
    fill: "#6967BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2638 42.6902H74.5375C76.812 42.6902 78.6561 44.534 78.6561 46.8088V88.4838H86.3824V46.8088C86.3824 44.5342 84.5383 42.6902 82.2638 42.6902Z",
    fill: "#5B59B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8814 96H4.11862C1.84387 96 0 94.1561 0 91.8814V88.4837H96V91.8814C96 94.1561 94.1561 96 91.8814 96Z",
    fill: "#7776D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2737 88.4838V91.8815C88.2737 94.1561 86.4298 96.0001 84.155 96.0001H91.8814C94.1559 96.0001 96 94.1563 96 91.8815V88.4838H88.2737Z",
    fill: "#6967BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4683 49.5541H79.5316V88.4838H16.4683V49.5541Z",
    fill: "#D9DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1399 4.65634C50.8166 -3.70672 34.0483 -0.49822 25.6868 11.8228C17.3252 24.1438 20.5369 40.9115 32.86 49.2746C36.3688 51.6558 40.2385 53.0977 44.1715 53.6593L47.9666 59.5177L51.9585 53.6357C59.158 52.5665 65.9044 48.6048 70.3131 42.1082C78.6748 29.7872 75.4631 13.0194 63.1399 4.65634Z",
    fill: "#FFD54D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1399 4.65635C57.3482 0.725792 50.5744 -0.648583 44.1531 0.277667C48.0686 0.844479 51.9197 2.28523 55.4136 4.65635C67.7368 13.0194 70.9485 29.7872 62.5868 42.1082C58.1779 48.6047 51.4315 52.5666 44.2322 53.6357L44.1934 53.6931L47.9668 59.5179L51.9587 53.6359C59.1581 52.5667 65.9046 48.605 70.3133 42.1084C78.6748 29.7872 75.4631 13.0194 63.1399 4.65635Z",
    fill: "#FFC919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 43.2305C46.0249 43.2305 44.4238 41.6295 44.4238 39.6543V27.9346C44.4238 25.9595 46.0249 24.3585 48 24.3585C49.9751 24.3585 51.5762 25.9595 51.5762 27.9346V39.6543C51.5762 41.6293 49.9751 43.2305 48 43.2305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 19.113C46.0249 19.113 44.4238 17.5119 44.4238 15.5368C44.4238 13.5617 46.0249 11.9606 48 11.9606C49.9751 11.9606 51.5762 13.5617 51.5762 15.5368C51.5762 17.5117 49.9751 19.113 48 19.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1764 62.7217H35.9528C36.7529 62.7217 37.4014 62.0732 37.4014 61.2731C37.4014 60.4731 36.7529 59.8245 35.9528 59.8245H25.1764C24.3763 59.8245 23.7278 60.4731 23.7278 61.2731C23.7276 62.073 24.3763 62.7217 25.1764 62.7217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0475 62.7217H70.8239C71.6239 62.7217 72.2725 62.0732 72.2725 61.2731C72.2725 60.4731 71.6239 59.8245 70.8239 59.8245H60.0475C59.2474 59.8245 58.5989 60.4731 58.5989 61.2731C58.5987 62.073 59.2472 62.7217 60.0475 62.7217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8237 68.2263H25.1764C24.3763 68.2263 23.7278 68.8749 23.7278 69.675C23.7278 70.475 24.3763 71.1236 25.1764 71.1236H70.8238C71.6239 71.1236 72.2725 70.475 72.2725 69.675C72.2725 68.8749 71.6237 68.2263 70.8237 68.2263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1657 76.6282H34.8344C34.0343 76.6282 33.3857 77.2768 33.3857 78.0769C33.3857 78.8769 34.0343 79.5255 34.8344 79.5255H61.1659C61.966 79.5255 62.6146 78.8769 62.6146 78.0769C62.6146 77.2768 61.9658 76.6282 61.1657 76.6282Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1743:173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/card (2).c40237a094c5cba8eb202017b8ee12b1.svg";
export { ForwardRef as ReactComponent };